<template>
  <div class="w-full py-8">
    <div class="gridClass text-center">
      <div class="flex flex-col">
        <div class="font-bold text-blue-700 mb-3 text-xl lg:text-2xl">
          {{ details.title }}
        </div>
        <div class="text-blue-700 text-lg lg:text-xl">
          {{ details.desc }}
        </div>
      </div>
      <div class="flex flex-col lg:flex-row justify-between lg:justify-evenly w-full mt-8 text-blue-700 items-center">
        <a v-for="method in details.communicationMethods" :key="method.id" :href="method.link.href" class="my-3">
          <NuxtImg
            width="400"
            :src="method.img"
            :alt="method.title"
            class="w-full aspect-square mb-3"
          />
            {{ method.title }}
          <div class="text-blue font-bold px-4 py-1 shadow mt-3">
            {{ method.link.text }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  details: Object,
})
</script>
